export type DigitalPresence = {
  readonly id?: number
  readonly type: DigitalPresenceType
  readonly label?: string
  readonly value: string | File
  readonly toDelete?: boolean
}

export enum DigitalPresenceType {
  crunchbaseId = 'Crunchbase id',
  crunchbaseUrl = 'Crunchbase URL',
  documentUrl = 'Document URL',
  email = 'Email',
  facebookId = 'Facebook id',
  facebookUrl = 'Facebook URL',
  logoUrl = 'Logo URL',
  linkedinUrl = 'Linkedin URL',
  profilePictureUrl = 'Profile picture URL',
  twitterUrl = 'Twitter URL',
  websiteUrl = 'Website URL',
}
